module.exports = __webpack_public_path__ + "img/group-icon.410e0adc.svg";